import Vue from 'vue'
export const getNotificacoes = async ({ commit, state }) => {
  let res = await Vue.prototype.axios.post('notificacoes')
  let notificacoesAntigas = Object.assign({}, state.app.notificacoes)
  let count = notificacoesAntigas && notificacoesAntigas !== null && Object.values(notificacoesAntigas).length > 0 ? notificacoesAntigas.count : null
  let notificacoes = res.data.data

  commit('setNotificacoes', notificacoes)
  if (!("Notification" in window)) return
  if (Notification.permission === 'granted' && count !== null && (parseInt(notificacoes.count) - parseInt(count)) > 0) {
    var myNotification = new Notification('Uma nova notificação', { body: 'Novas notificações estão disponíveis no BR-Corte!!!', icon: 'https://brcorte.com.br/favicon.png' })
    myNotification.addEventListener('click', () => {
      window.location.href = '/'
    })
  }
}
export const setDietaLida = async ({ dispatch }, dieta) => {
  dieta.id = !dieta.id_dieta ? dieta.id : dieta.id_dieta
  dieta.id_compartilhamento = (!dieta.id_compartilhamento && dieta.compartilhamento) ? dieta.compartilhamento.id_compartilhamento : (dieta.id_compartilhamento) ? dieta.id_compartilhamento : null
  let res = await Vue.prototype.axios.post('notificacoes/dietaLida', { id: dieta.id, id_compartilhamento: dieta.id_compartilhamento, id_pessoa: dieta.id_pessoa })
  dispatch('getNotificacoes')
  return res
}
